import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 新增消杀记录
  projectDisinfectRecordsave(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDisinfectRecord/save',
      method: 'post',
      data: data
    })
  },
  // 删除消杀记录
  projectDisinfectRecordremove(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDisinfectRecord/remove/' + id,
      method: 'get'
    })
  },
  // 查询消杀记录
  projectDisinfectRecordgetById(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDisinfectRecord/getById/' + id,
      method: 'get'
    })
  },
  // 消杀记录列表
  projectDisinfectRecordpage(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDisinfectRecord/page',
      method: 'post',
      data: data
    })
  },
  // 当前人员消杀记录列表
  projectDisinfectRecordgetOwnList(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDisinfectRecord/getOwnList',
      method: 'post',
      data: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/disinfect/index.js